<template>
  <div>
    <assign-training
      v-if="assignUserDialog"
      :dialog="assignUserDialog"
      :video-id="selectedVideoId"
      :item-id="selectedVideoId"
      item-type="video"
      @update:dialog="assignUserDialog = $event"
    />
    <video-popup v-if="preview" :dialog="preview" :data="videoLoaded" @closed="preview = false, videoLoaded = null" :clickToClose="true" @close="preview = false,videoLoaded = null"/>

    <div class="mt-5 pt-4">
      <nav class="mb-5" style="--bs-breadcrumb-divider: url(&#34;data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='10'%3E%3Cpath d='M2.5 0L1 1.5 3.5 4 1 6.5 2.5 8l4-4-4-4z' fill='black'/%3E%3C/svg%3E&#34;);" aria-label="breadcrumb">
        <ol class="breadcrumb">
          <li class="breadcrumb-item" style="font-size:24px; line-height: 24px; font-weight:900; color:#435666;"><strong>Training</strong></li>
          <li class="breadcrumb-item active" aria-current="page" style="font-size:24px; line-height: 24px; font-weight:300; color:#435666;">Settings</li>
        </ol>
      </nav>

      <div class="mt-4">
        <div class="row">
          <div class="col-md-12">
            <div>
              <div>

                <div class="row">
                  <div v-if="loading" class="text-center align-middle py-5">
                    <img src="@/assets/img/loading.svg">
                  </div>
                </div>

                <div v-show="!loading">
                  <div class="card shadow-sm border-0 rounded-4 main-app-card mt-1">

                    <div class="custom-tabs-header d-flex align-items-center flex-wrap py-2 gap-4">

                      <div class="d-flex">
                        <button class="custom-tab" :class="{ active: activeTab === 'catalog' }" @click="activeTab = 'catalog'">
                          Course Catalog
                        </button>
                        <button class="custom-tab" :class="{ active: activeTab === 'modules' }" @click="activeTab = 'modules'">
                          Training Library
                        </button>
                      </div>

                     <div class="sleek-search-wrapper ms-2">
                        <i class="fas fa-search search-icon"></i>
                        <input type="text" class="sleek-search-input" placeholder="Search training..." v-model="search" autocomplete="off">
                      </div>

                      <button v-if="isBambooEnabled" type="button" class="btn btn-theme text-white btn-sm rounded-pill px-3 shadow-sm d-flex align-items-center ms-auto" @click="syncBamboo" :disabled="isBambooSyncing">
                        <span v-if="isBambooSyncing" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                        <i v-if="!isBambooSyncing" class="fas fa-sync-alt me-1"></i>
                        <span v-if="!isBambooSyncing">Sync BambooHR</span>
                        <span v-if="isBambooSyncing">Syncing...</span>
                      </button>

                    </div>
                    <div class="card-body p-4 bg-light-surface">

                      <div v-if="activeTab === 'catalog'" class="catalog-view">
                        <div class="d-flex justify-content-between align-items-center mb-4 mt-2">
                          <h4 class="section-title mb-0">Program & Category Management</h4>
                          <button class="btn btn-theme text-white btn-sm rounded-pill px-3 shadow-sm" @click="openNewCategoryModal">
                            <i class="fas fa-plus me-1"></i> New Category
                          </button>
                        </div>

                        <div class="accordion-category" v-for="category in filteredCategories" :key="category.id">
                          <div class="category-header d-flex justify-content-between align-items-center" :class="{ 'is-expanded': category.expanded }" @click="category.expanded = !category.expanded">
                            <div class="d-flex align-items-center fw-bold text-dark">
                              <i class="fas fa-folder icon-category me-2"></i>
                              Category: {{ category.name }}
                            </div>
                            <div class="d-flex align-items-center gap-2">
                              <template v-if="!category?.isDefault">
                                <button class="header-icon-btn" @click.stop="openEditCategoryModal(category)" title="Edit Category"><i class="fas fa-pencil-alt"></i></button>
                                <button
                                  class="header-icon-btn delete-btn"
                                  @click.stop="deleteCategory(category.id)"
                                  :disabled="category.programs && category.programs.length > 0"
                                  :title="category.programs && category.programs.length > 0 ? 'Cannot delete: Category contains programs' : 'Delete Category'"
                                >
                                  <i class="fas fa-trash"></i>
                                </button>
                                <button class="btn btn-outline-theme btn-xs rounded-pill ms-2" @click.stop="addProgram(category.id)">+ Program</button>
                              </template>
                              <i class="fas text-secondary ms-2" :class="category?.expanded ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
                            </div>
                          </div>

                          <div class="category-body" v-show="category.expanded">
                            <div class="p-3">
                              <div v-if="category.programs.length === 0" class="text-muted small ms-4">No programs in this category.</div>

                              <div class="accordion-program mb-3" v-for="program in category.programs" :key="program.id">
                                <div class="program-header d-flex justify-content-between align-items-center" :class="{ 'is-expanded': program.expanded }" @click="program.expanded = !program.expanded">
                                  <div class="d-flex align-items-center fw-bold text-dark">
                                    <i class="fas fa-trophy icon-program me-2"></i>
                                    Program: {{ program.title }}
                                  </div>

                                  <div class="d-flex align-items-center gap-2">
                                    <span class="text-muted small d-none d-lg-block me-3 d-flex align-items-center">
                                      <i class="fas fa-layer-group me-1"></i> {{ program?.modules?.length || 0 }} Trainings |
                                      <i class="far fa-clock me-1 ms-2"></i> {{ program?.assignment_frequency }} |
                                      <span class="ms-2 fw-semibold" :class="{
                                        'text-success': program?.status === 'published',
                                        'text-danger': program?.status === 'locked',
                                        'text-warning': program?.status !== 'published' && program?.status !== 'locked'
                                      }">
                                        {{ program?.status === 'published' ? 'Published' : (program?.status === 'locked' ? 'Locked' : 'Draft') }}
                                      </span>

                                      <span class="ms-2 me-2 text-muted">|</span>
                                      <div class="d-inline-flex align-items-center" @click.stop v-tooltip.top="program.isDefault ? 'Mandatory for Vertex managed programs' : 'Enable/disable training reminders'">
                                        <label class="pure-toggle minimal-toggle mb-0" :class="{ 'disabled-toggle': program.isDefault }">
                                          <input type="checkbox" v-model="program.enable_reminders" :disabled="program.isDefault" @change="toggleProgramReminder(category.id, program)">
                                          <span class="pure-slider"></span>
                                        </label>
                                      </div>
                                    </span>
                                    <template v-if="!program?.isDefault">
                                      <button class="header-icon-btn" @click.stop="openEditProgramModal(program, category.id)" title="Edit Program"><i class="fas fa-pencil-alt"></i></button>
                                      <button class="header-icon-btn delete-btn" @click.stop="deleteProgram(category.id, program.id)" title="Delete Program"><i class="fas fa-trash"></i></button>
                                      <button class="btn btn-outline-secondary btn-xs rounded-pill ms-2" @click.stop="addModule(category.id, program.id)"  :disabled="program?.status == 'locked'">+ Training</button>
                                    </template>

                                    <span @click.stop v-if="!program?.isDefault">
                                      <button class="btn btn-outline-info btn-xs rounded-pill ms-1 d-inline-flex align-items-center"
                                        @click="assignProgram(program.id)"
                                        :disabled="program?.status !== 'published'"
                                        :title="program?.status !== 'published' ? 'Must be published to assign' : 'Assign Users'"
                                      >
                                        <i class="fas fa-user-plus me-1"></i> <span style="line-height: 1;">Assign</span>
                                        <span class="badge bg-info text-white ms-2 d-inline-flex align-items-center justify-content-center"
                                              v-tooltip.top="(program.assignment_type === 'all' || (totalActiveUsers > 0 && program.assigned_users_count >= totalActiveUsers)) ? 'Assigned to all users' : `${program.assigned_users_count || 0} of ${totalActiveUsers} users`"
                                              style="border-radius: 10px; font-size: 0.7rem; padding: 2px 7px; height: 18px; line-height: 1;">
                                          {{ (program.assignment_type === 'all' || (totalActiveUsers > 0 && program.assigned_users_count >= totalActiveUsers)) ? 'All' : (program.assigned_users_count || 0) }}
                                        </span>
                                      </button>
                                    </span>

                                    <i class="fas text-secondary ms-2" :class="program?.expanded ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
                                  </div>
                                </div>

                                <div class="program-body" v-show="program.expanded">
                                  <div class="p-3 bg-white">
                                    <div class="text-muted small fw-bold mb-2 ms-2">Assigned Trainings</div>
                                    <div v-if="program.modules.length === 0" class="text-muted small ms-2">No modules assigned.</div>

                                    <div class="module-item"
                                      v-for="(module, index) in program.modules"
                                      :key="module.id"
                                      :draggable="!program.isDefault"
                                      @dragstart="!program.isDefault ? onDragStart(index) : null"
                                      @dragover.prevent
                                      @dragenter.prevent
                                      @drop="onDrop(category.id, program, index)"
                                      @dragend="draggedItemIndex = null"
                                      :style="!program.isDefault ? 'cursor: grab;' : 'cursor: default;'"
                                    >
                                      <div class="d-flex align-items-center">
                                        <i v-if="!program.isDefault" class="fas fa-grip-vertical text-muted me-3 fs-5" title="Drag to reorder"></i>

                                        <i class="fas fa-box icon-module me-3 module-icon"></i>
                                        <span class="fw-semibold text-dark">Training {{ index + 1 }}: {{ module.name }}</span>

                                        <span v-if="module.type === 'video' && !module.isDefaultVideo" class="badge bg-secondary border ms-3"><i class="fas fa-play-circle"></i> Video</span>
                                        <span v-if="module.type === 'scorm'" class="badge bg-theme text-white border ms-3"><i class="fas fa-laptop-code"></i> SCORM {{ module.scorm_version }}</span>
                                        <span v-if="module.isDefaultVideo" class="badge bg-theme text-white border ms-3"><i class="fas fa-shield-alt"></i> Vertex</span>
                                      </div>

                                      <div class="d-flex align-items-center gap-2">
                                        <button class="btn btn-sm btn-light btn-circle" title="Preview" @click="previewLibraryModule(module)">
                                          <i class="fas fa-play text-success"></i>
                                        </button>

                                        <template v-if="!program.isDefault">
                                          <button class="btn btn-sm btn-light btn-circle ms-1" title="Remove from Program"  :disabled="program?.status == 'locked'" @click="removeModuleFromProgram(category.id, program.id, module.id)">
                                            <i class="fas fa-unlink text-danger"></i>
                                          </button>
                                        </template>
                                      </div>
                                    </div>

                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div v-if="activeTab === 'modules'" class="modules-view">
                        <div class="d-flex justify-content-between align-items-center mb-4 mt-2">
                          <div class="d-flex align-items-center">
                            <h4 class="section-title mb-0 me-4">Training Library</h4>

                            <div class="d-flex flex-row align-items-center">
                              <span class="p-2" style="color: #435666; font-size: 14px; font-weight: 500;">
                                  <i class="fa-solid fa-list-ol me-1"></i> Items per page
                              </span>
                              <select v-model="libraryPagination.pageSize" class="form-select shadow-none" style="width: auto; border: 1px solid #00A0C1; border-radius: 20px; color: #435666; height: 32px; padding: 0.1rem 2.2rem 0.1rem 1rem;">
                                  <option v-for="row in rowsPerPageList" :value="row.value" :key="row.value">{{ row.text }}</option>
                              </select>
                            </div>
                          </div>

                          <button class="btn btn-theme text-white btn-sm rounded-pill px-3 shadow-sm" @click="openUploadModal">
                            <i class="fas fa-upload me-1"></i> Upload Training
                          </button>
                        </div>

                        <div class="table-responsive bg-white rounded-3 border">
                          <table class="table table-hover align-middle mb-0">
                             <thead class="table-light align-middle text-start">
                              <tr>
                                <th class="w-50">Training Name</th>
                                <th>Type</th>
                                <th>Version</th>
                                <th>File/Path</th>
                                <th class="text-start" style="width: 1%; white-space: nowrap;">Actions</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr v-for="mod in filteredLibraryModules" :key="mod.id">
                                <td class="fw-bold">{{ mod.name }}</td>
                                <td>
                                  <span class="badge" :class="mod.type === 'video' ? 'bg-secondary' : 'bg-theme'">
                                    <i :class="mod.type === 'video' ? 'fas fa-play-circle' : 'fas fa-laptop-code'" class="me-1"></i>
                                    {{ mod.type === 'video' ? 'Video' : 'SCORM' }}
                                  </span>
                                </td>
                                <td>{{ mod.scorm_version || '--' }}</td>
                                <td class="text-muted small">{{ mod.display_path }}</td>

                                <td class="align-middle">
                                  <template v-if="mod.isDefaultVideo">
                                    <div class="d-flex justify-content-start align-items-center">
                                      <button type="button" class="btn btn-outline-primary btn-sm custom-disabled-btn me-2" v-tooltip.top="'Re-assign this video for ad hoc completion by all users'" @click="assignVideos(mod)" v-show="mod.is_active" style="border-radius: 50%; width: 30px; height: 30px; padding: 0; display: inline-flex; align-items: center; justify-content: center;"><i class="fas fa-redo"></i></button>
                                      <button type="button" class="btn btn-outline-primary btn-sm custom-disabled-btn me-3" v-tooltip.top="'Set this video as the next video for completion'" @click="setAssignUserDialog(mod)" v-show="mod.is_active" style="border-radius: 50%; width: 30px; height: 30px; padding: 0; display: inline-flex; align-items: center; justify-content: center;"><i class="fas fa-forward"></i></button>
                                      <label class="pure-toggle me-3 mb-0" v-tooltip.top="'Enable/disable video'"><input type="checkbox" v-model="mod.is_active" @change="changeStatus(mod)"><span class="pure-slider"></span></label>
                                      <button class="btn btn-sm btn-light btn-circle" title="Preview" @click="previewLibraryModule(mod)"><i class="fas fa-play text-success"></i></button>
                                    </div>
                                  </template>
                                 <template v-else>
                                    <div class="d-flex justify-content-start align-items-center">
                                      <button class="btn btn-sm btn-light btn-circle me-1" title="Assign Ad-Hoc Training" @click="assignVideos(mod)"><i class="fas fa-user-plus text-info"></i></button>
                                      <button class="btn btn-sm btn-light btn-circle me-1" title="Preview" @click="previewLibraryModule(mod)"><i class="fas fa-play text-success"></i></button>

                                   <button v-if="mod.type === 'video'" class="btn btn-sm btn-light btn-circle me-1" title="Manage Quiz" data-testid="btn-manage-module-quiz" @click="$router.push(`/training/settings/library/module/${mod.id}/quiz`)">
                                    <span>
                                      <quiz-icon />
                                    </span>
                                  </button>

                                      <button class="btn btn-sm btn-light btn-circle me-1" title="Edit Training" @click="openEditLibraryModule(mod)"><i class="fa fa-pen"></i></button>
                                      <button class="btn btn-sm btn-light btn-circle" title="Delete Training" @click="deleteLibraryModule(mod.id)" :disabled="deletingModuleId === mod.id"><i v-if="deletingModuleId === mod.id" class="fas fa-spinner fa-spin text-danger"></i><i v-else class="fas fa-trash text-danger"></i></button>
                                    </div>
                                  </template>
                                </td>
                              </tr>
                              <tr v-if="libraryModules.length === 0">
                                <td colspan="5" class="text-center text-muted py-4">No trainings in the library. Upload one to get started!</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>

                       <div class="text-center mt-4 mb-2" v-if="!loading && libraryPagination.totalItems > 0">
                          <div class="d-inline pagination">
                            <a @click="handleLibraryPageChange(libraryPagination.page - 1)"
                               class="pagination-arrow"
                               :class="{ 'disabled': libraryPagination.page === 1 }">
                              <i class="fa fa-chevron-left"></i>
                            </a>
                            <span class="pagination-label">
                              <strong>
                                <span>{{ ((libraryPagination.page - 1) * libraryPagination.pageSize) + 1 }} - {{ Math.min(libraryPagination.page * libraryPagination.pageSize, libraryPagination.totalItems) }} of {{ libraryPagination.totalItems }}</span>
                              </strong>
                            </span>
                            <a @click="handleLibraryPageChange(libraryPagination.page + 1)"
                               class="pagination-arrow"
                               :class="{ 'disabled': libraryPagination.page === libraryPagination.totalPages || libraryPagination.totalItems === 0 }">
                              <i class="fa fa-chevron-right"></i>
                            </a>
                          </div>
                        </div>

                      </div>

                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <vue-final-modal v-model="linkDialog" classes="modal-container" content-class="modal-content">
      <span class="modal__title">P&P Link</span>
      <div class="modal__content mt-3 mb-4">
        <div>
          <input class="form-control" v-model="editedTraining.training_link" v-on:keyup.enter="editPrivacyAndProcedureLinks">
        </div>
      </div>
      <div class="modal__action">
        <button type="button" class="btn btn-outline-danger" @click="close">Close</button>
        <button class="btn btn-outline-primary" @click="editPrivacyAndProcedureLinks">Save</button>
      </div>
    </vue-final-modal>

    <vue-final-modal v-model="monthlyReportDialog" @before-close="recepientsCheck" classes="modal-container" content-class="modal-content-monthly">
      <span class="modal__title">Recipients</span>
      <div class="modal__content mt-3">
        <div :class="{ error: v$.editedMonthlyReport.email.$errors.length }">
          <div class="col mb-5">
            <label class="form-label">Email address</label>
            <div class="input-group">
              <input type="email" class="form-control" v-model="editedMonthlyReport.email" id="floatingInput" placeholder="name@example.com" @blur="v$.editedMonthlyReport.email.$touch()">
              <button type="button" class="btn btn-outline-primary" @click="saveMonthlyRecipient()">{{editedIndex == -1 ? 'Add' : 'Update'}}</button>
            </div>
            <div class="text-danger" v-for="error of v$.editedMonthlyReport.email.$errors" :key="error.$uid">
              <div class="form-text text-danger">{{ error.$message }}</div>
            </div>
          </div>
        </div>

        <div class="mt-5">
          <table class="table mb-5 mt-2">
            <thead>
              <tr class="table-light text-default">
                <th>Email</th>
                <th style="text-align: right;">Actions</th>
              </tr>
            </thead>
            <tbody v-for="(item, index) in monthlyReports" :key="index">
              <tr>
                <td>{{ item.email }}</td>
                <td style="text-align:right;">
                  <button type="button" class="btn btn-default btn-circle ms-1" @click="editMonthlyReport(item)"><i class="fas fa-edit"></i></button>
                  <button type="button" class="btn btn-default btn-circle-danger ms-1" @click="deleteMonthlyReport(item)"><i class="fas fa-trash"></i></button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="modal__action">
        <button type="button" class="btn btn-outline-danger" @click="closeMonthlyDialog">Close</button>
      </div>
    </vue-final-modal>

    <category-modal v-model="showCategoryModal" :is-edit="isEditingCategory" :initial-data="selectedCategoryData" @save="saveCategory" />
    <program-modal v-model="showProgramModal" :is-edit="isEditingProgram" :initial-data="selectedProgramData" :category-id="activeCategoryId" @save="saveProgram" />
    <!-- assignment of training modules -->
    <assign-module-modal
      v-model="showAssignModuleModal"
      :library-modules="assignableModules"
      :already-assigned-ids="currentProgramModuleIds"
      :is-on-demand="targetProgramIsOnDemand"
      :program-status="targetProgramStatusForModules"
      @save="saveAssignedModules"
    />

    <upload-module-modal
      v-model="showUploadModal"
      :is-edit="isEditingModule"
      :initial-data="selectedModuleData"
      :is-saving="isSavingModule"
      :upload-progress="uploadProgress"
      :is-processing-upload="isProcessingUpload"
      @save="saveLibraryModule"
    />
    <scorm-preview-modal v-model="showPreviewModal" :module-data="previewModuleData" />
    <delete-form
      :dialog="showDeleteModal"
      :id="deletePayload.id"
      :title="deletePayload.title"
      :message="deletePayload.message"
      :confirm-button-text="deletePayload.buttonText"
      @onChange="handleDeleteConfirm"
      @close="showDeleteModal = false"
    />
    <assign-user-modal
      v-model="showAssignUserModal"
      :org-id="orgID"
      :program-id="targetProgramIdForUsers"
      :module-id="targetModuleIdForUsers"
      :mode="userAssignmentMode"
      :is-all-type="targetProgramIsAll"
      @save="saveUserAssignments"
    />

    <adhoc-warning-modal
      v-model="showAdhocWarningModal"
      @confirm="proceedWithAdhocAssignment"
    />

  </div>
</template>

<script>
import moment from 'moment';
import { debounce } from '@/plugins/helper.js'
import { useVuelidate } from '@vuelidate/core'
import VideoPopup from "@/components/VideoPopup.vue";
import { required, email } from '@vuelidate/validators'
import AssignTraining from "@/components/training/AssignTraining.vue";

// LMS Modals
import DeleteForm from '@/components/Delete.vue';
import ProgramModal from '@/components/scorm/ProgramModal.vue';
import CategoryModal from '@/components/scorm/CategoryModal.vue';
import AssignUserModal from '@/components/scorm/AssignUserModal.vue';
import AssignModuleModal from '@/components/scorm/AssignModuleModal.vue';
import UploadModuleModal from '@/components/scorm/UploadModuleModal.vue';
import ScormPreviewModal from '@/components/scorm/ScormPreviewModal.vue';
import QuizIcon from '@/components/icons/QuizIcon.vue';

//adhoc modal
import AdhocWarningModal from '@/components/training/AdhocWarningModal.vue';

export default {
  name: "Training Settings",

  components: {
    VideoPopup,
    AssignTraining,
    CategoryModal,
    ProgramModal,
    AssignModuleModal,
    UploadModuleModal,
    ScormPreviewModal,
    DeleteForm,
    AssignUserModal,
    AdhocWarningModal,
    QuizIcon
  },

  setup () {
    return { v$: useVuelidate() }
  },

  validations () {
    return {
      editedMonthlyReport: {
        email: {required, email},
      }
    }
  },

  data() {
    return {
      // Original Settings Data
      loading: false,
      search: '',
      linkDialog: false,
      monthlyReportDialog: false,
      isBambooSyncing: false,
      selectedVideoId: null,
      assignUserDialog: false,
      orgID: this.$helper.setOrganisationID(),
      editedIndex: -1,
      editedTraining: { training_link: '' },
      editedMonthlyReport: { email: '' },
      id: 0,
      monthlyReports:[],
      monthlyReport: false,
      trainingReminder: false,
      addRecipientRequired: false,
      btnReport: "#00A0C1",
      btnReminderStroke: "#00A0C1",
      btnReminderFill: "white",
      vssWidth: 3000,
      preview: false,
      videoLoaded: null,

      // LMS Settings Data
      activeTab: 'catalog',
      libraryPagination: {
        pageSize: 10,
        page: 1,
        totalItems: 0,
        totalPages: 1,
      },
      rowsPerPageList: [
        { text: "5", value: 5 },
        { text: "10", value: 10 },
        { text: "20", value: 20 },
      ],
      categories: [
        {
          id: 'default-cat',
          name: 'Vertex Managed Training',
          expanded: true,
          isDefault: true,
          programs: [
            {
              id: 'default-prog',
              title: 'Cyber Security Awareness Training',
              status: 'published',
              assignment_frequency: 'Default',
              expanded: true,
              isDefault: true,
              modules: [],
              enable_reminders: true,
              is_mandatory: true,
            }
          ]
        }
      ],
      libraryModules: [],

      // LMS Modal States
      showCategoryModal: false,
      isEditingCategory: false,
      selectedCategoryData: null,
      showProgramModal: false,
      isEditingProgram: false,
      selectedProgramData: null,
      activeCategoryId: null,
      showAssignModuleModal: false,
      targetProgramIdForModules: null,
      targetCategoryIdForModules: null,
      showUploadModal: false,
      targetProgramIsOnDemand: false,
      showPreviewModal: false,
      previewModuleData: null,
      isEditingModule: false,
      selectedModuleData: null,
      isSavingModule: false,
      showDeleteModal: false,
      deletePayload: { id: 0, type: '', title: '', message: '', context: {}, buttonText: 'Delete' },
      showAssignUserModal: false,
      targetProgramIdForUsers: null,
      targetModuleIdForUsers: null,
      userAssignmentMode: 'program',
      targetProgramIsAll: false,
      totalActiveUsers: 0,
      draggedItemIndex: null,
      deletingModuleId: null,
      uploadProgress: 0,
      isProcessingUpload: false,
      fullLegacyModules: [],
      assignableModules: [],

      //adhoc modal
      showAdhocWarningModal: false,
      pendingAdhocItem: null,

      activeUserIds: [],
      targetProgramStatusForModules: null,

    }
  },

  mounted() {
    this.vssWidth = this.$vssWidth;
    this.init()
  },

  methods: {
    confirm() {
      this.showConfirmModal = false
      this.linkDialog = false
    },

    async init(){
      this.loading = true;
      await this.fetchTotalUsers();
      await this.fetchLegacyModules();
      await this.fetchModules();
      await this.fetchCategories();
      this.checkEnabledFeatures();
      this.loading = false;
    },

    async fetchLegacyModules() {
      try {
        const response = await this.$axios.get(`/orgadmin/trainings/organisations/${this.orgID}/legacy-modules`);
        if (response.data.success) {
          const rawLegacyList = response.data.legacy_modules || [];

          rawLegacyList.sort((a, b) => {
             const seqA = a.assign_sequence ?? a.AssignSequence ?? a.id ?? a.ID ?? 0;
             const seqB = b.assign_sequence ?? b.AssignSequence ?? b.id ?? b.ID ?? 0;
             return seqA - seqB;
          });

          // Map them exactly how the rest of the app expects
          this.fullLegacyModules = rawLegacyList.map(m => {
            return {
              id: m.id || m.ID,
              training_video_id: m.legacy_video_id || m.LegacyVideoID,
              name: m.name || m.Name,
              type: "video",
              scorm_version: null,
              launch_path: m.gcs_path || m.GcsPath || '--',
              display_path: 'Vertex Content Server',
              gcs_path: m.gcs_path || m.GcsPath,
              thumbnail: m.thumbnail || m.Thumbnail,
              isDefaultVideo: true, // Crucial for the Course Catalog
              is_active: m.is_active !== undefined ? m.is_active : true,
              originalData: m
            };
          });
        }
      } catch (error) {
        console.error("Error fetching legacy modules:", error);
      }
    },


  async fetchTotalUsers() {
      try {
        const response = await this.$axios.get(`/users/organisations/${this.orgID}`);
        if (response.data.success) {
          const activeUsers = response.data.users || [];
          this.totalActiveUsers = activeUsers.length;
          this.activeUserIds = activeUsers.map(u => u.id);
        }
      } catch (error) {
        console.warn("Could not fetch total users for legacy calculation", error);
      }
    },
    async fetchModules() {
      try {
        const params = {
          page: this.libraryPagination.page,
          limit: this.libraryPagination.pageSize,
          filter: this.search
        };

        const response = await this.$axios.get(`/orgadmin/trainings/organisations/${this.orgID}/training-modules`, { params });

        if (response.data.success) {
          const modulesList = response.data.training_modules || response.data.modules || [];

          this.libraryPagination.totalItems = response.data.total || modulesList.length;
          this.libraryPagination.totalPages = Math.ceil(this.libraryPagination.totalItems / this.libraryPagination.pageSize) || 1;

          this.libraryModules = modulesList.map(m => {
            const isDefault = m.is_default_video || m.IsVertexDefault || false;
            const type = (m.type || m.Type || '').toLowerCase();

            let displayPath = m.launch_path || m.LaunchPath || '--';
            if (type === 'video') {
              displayPath = isDefault ? 'Vertex Content Server' : 'Secure Video File';
            }

            return {
              id: m.id || m.ID,
              training_video_id: m.legacy_video_id || m.LegacyVideoID,
              name: m.name || m.Name,
              type: type,
              scorm_version: m.scorm_version || m.ScormVersion,
              launch_path: m.launch_path || m.LaunchPath || m.gcs_path || m.GcsPath || '--',
              display_path: displayPath,
              gcs_path: m.gcs_path || m.GcsPath,
              thumbnail: m.thumbnail || m.Thumbnail,
              isDefaultVideo: isDefault,
              is_active: m.is_active !== undefined ? m.is_active : true,
              originalData: m
            };
          });
        }
      } catch (error) {
        console.error("Error fetching library trainings:", error);
      }
    },

    handleLibraryPageChange(newPage) {
      if (newPage > 0 && newPage <= this.libraryPagination.totalPages) {
        this.libraryPagination.page = newPage;
        this.fetchModules();
      }
    },

    async fetchCategories() {
      try {
        const expandedCategoryIds = new Set(this.categories.filter(c => c.expanded).map(c => c.id));
        const expandedProgramIds = new Set();
        this.categories.forEach(c => {
          if (c.programs) {
            c.programs.forEach(p => {
              if (p.expanded) expandedProgramIds.add(p.id);
            });
          }
        });

        const response = await this.$axios.get(`/orgadmin/trainings/organisations/${this.orgID}/categories`);
        if (response.data.success) {

          const defaultCat = this.categories.find(c => c?.isDefault);
          const rawCategories = response.data.training_categories || [];

          const backendCategories = rawCategories.filter(c => c != null).map(cat => ({
            id: cat.id || cat.ID,
            name: cat.name || cat.Name || 'Unnamed Category',

            // Re-apply expanded state based on our snapshot
            expanded: expandedCategoryIds.has(cat.id || cat.ID) || false,
            isDefault: false,
            programs: (cat.programs || cat.Programs || []).filter(p => p != null).map(p => ({
              id: p.id || p.ID,
              title: p.title || p.Title || 'Unnamed Program',
              status: p.status || p.Status || 'draft',
              assignment_frequency: p.assignment_frequency || p.AssignmentFrequency || 'On Demand',

              enable_reminders: p.enable_reminders !== undefined ? p.enable_reminders : (p.EnableReminders !== undefined ? p.EnableReminders : true),
              is_mandatory: p.is_mandatory !== undefined ? p.is_mandatory : (p.IsMandatory !== undefined ? p.IsMandatory : true),

              assignment_type: p.assignment_type || p.AssignmentType || 'individual',

              assigned_users_count: (p.enrollments && p.enrollments.length > 0) || (p.Enrollments && p.Enrollments.length > 0)
                ? [...new Set((p.enrollments || p.Enrollments).map(e => e.user_id || e.UserID))].filter(id => this.activeUserIds.includes(id)).length
                : (p.enrolled_users_count || p.EnrolledUsersCount || p.assigned_users_count || p.AssignedUsersCount || 0),

               // Re-apply expanded state based on our snapshot
               expanded: expandedProgramIds.has(p.id || p.ID) || false,
               isDefault: false,
               modules: (p.modules || p.Modules || []).map(m => {
                  const isDefault = m.is_default_video || m.IsVertexDefault || false;
                  const type = (m.type || m.Type || '').toLowerCase();

                  let displayPath = m.launch_path || m.LaunchPath || '--';
                  if (type === 'video') {
                    displayPath = isDefault ? 'Vertex Content Server' : 'Secure Video File';
                  }

                 return {
                    id: m.id || m.ID,
                    training_video_id: m.legacy_video_id || m.LegacyVideoID,
                    name: m.name || m.Name,
                    type: type,
                    scorm_version: m.scorm_version || m.ScormVersion,
                    launch_path: m.launch_path || m.LaunchPath || m.gcs_path || m.GcsPath || '--',
                    display_path: displayPath,
                    gcs_path: m.gcs_path || m.GcsPath,
                    thumbnail: m.thumbnail || m.Thumbnail,
                    isDefaultVideo: isDefault,
                    is_active: m.is_active !== undefined ? m.is_active : true,
                    originalData: m
                  };
               })
            }))
          }));

          if (defaultCat && defaultCat.programs.length > 0) {
              defaultCat.programs[0].modules = this.fullLegacyModules.filter(m => m.isDefaultVideo && m.is_active);
              defaultCat.programs[0].enable_reminders = true;
              defaultCat.programs[0].is_mandatory = true;
          }

          this.categories = defaultCat ? [defaultCat, ...backendCategories] : backendCategories;

          this.categories.forEach(cat => {
            cat.programs.forEach(prog => {
              if (prog.assignment_type !== 'all' && !prog.isDefault) {
                this.$axios.get(`/orgadmin/trainings/organisations/${this.orgID}/programs/${prog.id}/enrollments`)
                  .then(enrollRes => {
                    if (enrollRes.data.success && enrollRes.data.enrollments) {
                      prog.assigned_users_count = [...new Set(enrollRes.data.enrollments.map(e => e.user_id || e.UserID))].filter(id => this.activeUserIds.includes(id)).length;
                    }
                  }).catch(() => {});
              }
            });
          });

        }
      } catch (error) {
        console.error("Error fetching categories:", error);
      }
    },

    async toggleProgramReminder(categoryId, program) {
      if (program.isDefault) return; // Prevent any accidental API calls for Vertex default

      try {
        const payload = {
          title: program.title,
          status: program.status,
          assignment_frequency: program.assignment_frequency,
          category_id: categoryId,
          assignment_type: program.assignment_type,
          enable_reminders: program.enable_reminders
        };

        const response = await this.$axios.put(`/orgadmin/trainings/organisations/${this.orgID}/programs/${program.id}`, payload);

        if (response.data.success) {
          this.$toast.success(program.enable_reminders ? 'Reminders enabled for this program.' : 'Reminders disabled for this program.');
        } else {
          program.enable_reminders = !program.enable_reminders; // Revert visually on failure
          this.$toast.error(response.data.message);
        }
      } catch (error) {
        program.enable_reminders = !program.enable_reminders; // Revert visually on error
        this.$toast.error(error.response?.data?.message || "Failed to update program reminder setting.");
      }
    },

    async saveCategory(categoryData) {
      try {
        if (this.isEditingCategory) {
          const response = await this.$axios.put(`/orgadmin/trainings/organisations/${this.orgID}/categories/${this.selectedCategoryData.id}`, {
            name: categoryData.name
          });

          if (response.data.success) {
            const index = this.categories.findIndex(c => c.id === this.selectedCategoryData.id);
            if (index !== -1) this.categories[index].name = response.data.training_category.name;
            this.$toast.success(response.data.message);
          } else {
            this.$toast.error(response.data.message);
          }
        } else {
          const response = await this.$axios.post(`/orgadmin/trainings/organisations/${this.orgID}/categories`, {
            name: categoryData.name
          });

          if (response.data.success) {
            this.categories.push({
              id: response.data.training_category.ID,
              name: response.data.training_category.name,
              expanded: true,
              programs: []
            });
            this.$toast.success(response.data.message);
          } else {
            this.$toast.error(response.data.message);
          }
        }
        this.showCategoryModal = false;
      } catch (error) {
        this.$toast.error(error.response?.data?.message || "An error occurred saving the category.");
      }
    },

    changeStatus(item) {
      const legacyId = item.originalData?.legacy_video_id || item.originalData?.LegacyVideoID || item.legacy_video_id;

      if (!legacyId) {
          // Revert the toggle visually if it's a custom module
          item.is_active = !item.is_active;
          this.$toast.error("Cannot toggle status on a custom uploaded module.");
          return;
      }

      let data = { is_active: item.is_active };

      this.$axios.put("/trainings/organisations/" + this.orgID + "/videos/" + legacyId, data)
      .then(async (response) => {
          if (response.data.success) {
              let message = item.name + " successfully " + (data.is_active ? "enabled." : "disabled.");
              this.$toast.success(message);

              const legacyIndex = this.fullLegacyModules.findIndex(m => m.training_video_id === legacyId);
              if (legacyIndex !== -1) {
                  this.fullLegacyModules[legacyIndex].is_active = item.is_active;
              }

              await this.fetchCategories();

          } else {
              item.is_active = !item.is_active;
              this.$toast.error(response.data.message);
          }
      }).catch(() => {
          // Revert on network error
          item.is_active = !item.is_active;
          this.$toast.error("Network error. Failed to update status.");
      });
    },

    // ... (Keep all your existing BambooHR, P&P, Monthly Reports exactly as they were) ...
    async editPrivacyAndProcedureLinks() {
      let data = { training_link: this.editedTraining.training_link };
      this.$axios.put("/orgadmin/trainings/organisations/"+ this.orgID +"/videos/" + this.id, data)
      .then((response) => {
        if (response.data.success) {
          this.close();
          this.$toast.success("P&P link has been updated.");
        }
      }).catch();
    },
    close() {
      this.linkDialog = false;
      this.editedTraining.training_link = null;
      this.editedIndex = -1;
      this.v$.$reset();
    },
    recepientsCheck(){
      if (this.monthlyReports.length == 0) {
        this.monthlyReport = false
        this.changeMonthlyReportStatus()
      }
    },
    closeMonthlyDialog(){
      this.monthlyReportDialog = false;
      this.editedMonthlyReport.email = null;
      this.v$.$reset();
      this.editedIndex = -1;
    },
    quizFinished(value){ return moment(value).format("LL") },
    async checkEnabledFeatures() {
      const orgFeatures = await this.getOrganisationFeatures();
      if (orgFeatures == null || orgFeatures.length < 1) {
        await this.createOrganisationFeature();
        this.addDefaultFeature();
      } else if(orgFeatures[0].monthly_report == null || orgFeatures[0].training_reminder == null) {
        this.addDefaultFeature();
      } else {
        await this.getMonthlyReportData();
        if (this.monthlyReports.length > 0) {
            this.monthlyReport = orgFeatures[0].monthly_report
        } else {
          this.updateOrganisationFeature(false);
          this.monthlyReport = false;
        }
        this.trainingReminder = orgFeatures[0].training_reminder
      }
    },
    async getOrganisationFeatures() {
      let data = await this.$axios.get(`/orgadmin/organisations/`+ this.orgID +`/organisation-feature`)
          .then((response) => {
              if (response.data.success) return response.data.org_features
              else { this.$toast.error(response.data.message); return null }
          }).catch()
      return data
    },
    async getMonthlyReportData(){
      let data = await this.$axios.get("/orgadmin/trainings/organisations/"+ this.orgID +"/user-report?report=monthly")
            .then((response) => {
              if (response.data.success) this.monthlyReports = response.data.user_reports
              else this.$toast.error(response.data.message)
            }).catch()
        return data
    },
    async updateOrganisationFeature(monthlyReport){
      let data = { organisation_id: this.orgID, monthly_report: monthlyReport }
      const orgFeature = await this.$axios.put("/orgadmin/organisations/"+ this.orgID +"/organisation-feature", data)
      return orgFeature
    },
    async addDefaultFeature() {
      const report = await this.addUserRecipient();
      this.setDefaultFeature();
      if (report) this.monthlyReport = true
    },
    async createOrganisationFeature(){
      let data = { organisation_id: this.orgID, monthly_report: true, training_reminder: true }
      const orgFeature = await this.$axios.post("/orgadmin/organisations/"+ this.orgID +"/organisation-feature", data)
      .then((response) => { return response.data.success ? true : false })
      return orgFeature
    },
    async addUserRecipient() {
      let data = { organisation_id: this.orgID, email: this.$store.state.user.organisation.primary_contact_email, monthly_report: true }
      const userReport = await this.$axios.post("/orgadmin/trainings/organisations/"+ this.orgID +"/user-report", data)
      .then((response) => {
        if (response.data.success){ this.getMonthlyReportData(); return true }
        else return false
      })
      return userReport
    },
    changeTrainingReminderStatus() {
      let data = { organisation_id: this.orgID, training_reminder: this.trainingReminder }
      this.$axios.put("/orgadmin/organisations/"+ this.orgID +"/organisation-feature", data)
      .then((response) => {
          if (response.data.success) {
              if (this.trainingReminder == true) this.$toast.success('Training Reminder has been enabled.')
              else this.$toast.success('Training Reminder has been disabled.')
          }
      }).catch();
    },
    setDefaultFeature() {
      this.trainingReminder = true;
      let data = { organisation_id: this.orgID, training_reminder: true, monthly_report: true }
      this.$axios.put("/orgadmin/organisations/"+ this.orgID +"/organisation-feature", data)
      .then((response) => { if (response.data.success) this.$toast.success("Default features enabled") }).catch();
    },
    changeMonthlyReportStatus(notify) {
      let data = { organisation_id: this.orgID, monthly_report: this.monthlyReport }
      if (this.addRecipientRequired == false) {
          if (this.monthlyReport && this.monthlyReports.length < 1) {
              this.monthlyReportDialog = true;
              this.addRecipientRequired = true;
              this.$toast.warning('Please add at least one recipient.')
              return
          }
      }
      this.$axios.put("/orgadmin/organisations/"+ this.orgID +"/organisation-feature", data)
      .then((response) => {
          if (response.data.success) {
            if (this.addRecipientRequired == false) {
              if (!notify) return
              if (this.monthlyReport == true) this.$toast.success('Monthly training report has been enabled.')
              else this.$toast.success('Monthly training report has been disabled.')
            }
            if (this.addRecipientRequired == true) this.addRecipientRequired = false;
          }
      }).catch();
    },
    editMonthlyReport(item) {
      this.editedIndex = this.monthlyReports.indexOf(item)
      this.editedMonthlyReport.email = item.email
      this.monthlyReportID = item.ID
    },
    saveMonthlyRecipient() {
      let toContinue = true
      this.monthlyReports.forEach(v => {
        if (v.email == this.editedMonthlyReport.email) {
          toContinue = false
          this.$toast.error("Recepient already exists.")
        }
      });
      if (!toContinue) return
      this.v$.editedMonthlyReport.email.$touch();
      if (this.v$.editedMonthlyReport.email.$invalid) return

      let data = { email: this.editedMonthlyReport.email, monthly_report: true }
      if (this.editedIndex > -1) {
          this.$axios.put("/orgadmin/trainings/organisations/"+ this.orgID +"/user-report/"+ this.monthlyReportID, data)
          .then((response) => {
              if (response.data.success){
                  this.$toast.success(response.data.message)
                  this.getMonthlyReportData();
                  this.editedIndex = -1;
                  this.editedMonthlyReport.email = null
              } else this.$toast.error(response.data.message)
          }).catch()
      } else {
          this.$axios.post("/orgadmin/trainings/organisations/"+ this.orgID +"/user-report", data)
          .then((response) => {
              if (response.data.success){
                this.editedMonthlyReport.email = null
                if (this.monthlyReports.length < 1) this.addRecipientRequired = true;
                if (this.addRecipientRequired == true) {
                  this.monthlyReportDialog = true;
                  this.changeMonthlyReportStatus();
                }
                this.$toast.success(response.data.message)
                this.getMonthlyReportData();
              } else this.$toast.error(response.data.message)
          }).catch()
      }
      this.v$.$reset();
    },
    deleteMonthlyReport(item) {
      this.editedIndex = this.monthlyReports.indexOf(item);
      if(confirm("Do you really want to delete this email?")) {
          this.$axios.delete("/orgadmin/trainings/organisations/"+ this.orgID +"/user-report/"+ item.ID)
          .then((response) => {
              if (response.data.success){
                  this.monthlyReports.splice(this.editedIndex, 1);
                  this.$toast.success(response.data.message)
                  this.editedIndex = -1;
              } else this.$toast.error(response.data.message)
          }).catch()
      }
    },
    changeTrainingReminderState(){ this.trainingReminder = !this.trainingReminder },

    setAssignUserDialog(video) {
      this.selectedVideoId = video.training_video_id;
      this.assignUserDialog = true;
    },

    async assignVideos(item) {
      const isLegacy = item.isDefaultVideo;
      const targetId = isLegacy ? (item.training_video_id || item.originalData?.legacy_video_id) : item.id;

      if (!targetId) {
        this.$toast.error(`Invalid ${isLegacy ? 'legacy' : 'custom'} module ID.`);
        return;
      }

      // Check for recent ad-hoc assignments
      let lastAdhocData = null;
      if (isLegacy) {
         lastAdhocData = await this.getLastAdhocVideo(targetId);
      } else {
         lastAdhocData = await this.getLastAdhocModule(targetId);
      }

      if (lastAdhocData != null) {
         const recordDate = lastAdhocData.CreatedAt || lastAdhocData.UpdatedAt || lastAdhocData.created_at;
         const createdAt = moment(recordDate);
         const oneDayAgo = moment().subtract(24, 'hours');
         const thirtyDaysAgo = moment().subtract(30, 'days');

         // QA Requirement: Hard Block for 24 hours
         if (!createdAt.isBefore(oneDayAgo)) {
            this.$toast.error("Training video can only be re-assigned once per day.");
            return;
         }

         // QA Requirement: Soft Warning for 30 days
         if (!createdAt.isBefore(thirtyDaysAgo, 'day')) {
            // Save the item context and open the modern warning modal
            this.pendingAdhocItem = { targetId, isLegacy };
            this.showAdhocWarningModal = true;
            return; // Halt here until they click 'Continue' in the modal
         }
      }

      // If it passes all checks (> 30 days), proceed immediately
      this.pendingAdhocItem = { targetId, isLegacy };
      this.proceedWithAdhocAssignment();
    },

    // Triggered instantly, OR triggered when they click 'Continue' in the warning modal
    proceedWithAdhocAssignment() {
      if (!this.pendingAdhocItem) return;

      this.userAssignmentMode = this.pendingAdhocItem.isLegacy ? 'legacy_module' : 'custom_module';
      this.targetModuleIdForUsers = this.pendingAdhocItem.targetId;
      this.showAssignUserModal = true;

      this.pendingAdhocItem = null; // Clear it out
    },

    async getLastAdhocModule(moduleId) {
      try {
         const response = await this.$axios.get(`/orgadmin/trainings/organisations/${this.orgID}/training-modules/${moduleId}/last-adhoc`);
         if (response.data.success && response.data.user_assignment) {
            return response.data.user_assignment;
         }
      } catch (e) {
         console.warn("Could not check last adhoc module time", e);
      }
      return null;
    },

    reAssignVideos(videoId) {
     this.$axios.post("/orgadmin/trainings/organisations/"+ this.orgID +"/reassign-video/" + videoId)
        .then((response) => {
          if (response.data.success){
            this.$toast.success(response.data.message)
          } else {
            this.$toast.error(response.data.message)
          }
      })
    },

    async getLastAdhocVideo(videoID){
      let data = await this.$axios.get("/orgadmin/trainings/organisations/"+ this.orgID +"/last-adhoc/"+videoID)
        .then((response) => { return response.data.success ? response.data.training_video : null })
        .catch(() => { return null });
      return data
    },

    syncBamboo() {
      this.isBambooSyncing = true
      this.$axios.post("/orgadmin/completed-trainings/organisations/"+ this.orgID +"/sync")
        .then((response) => {
          if (response.data.success) this.$toast.success(response.data.message)
          else this.$toast.error(response.data.message)
          this.isBambooSyncing = false
      })
    },

    // ----------------------------------------
    // LMS / SCORM METHODS
    // ----------------------------------------
    previewLibraryModule(module) {
      this.previewModuleData = module;
      this.showPreviewModal = true;
    },

    async addModule(categoryId, programId) {
      this.targetCategoryIdForModules = categoryId;
      this.targetProgramIdForModules = programId;

      //  Determine if the program is On Demand before opening the modal
      const category = this.categories.find(c => c.id === categoryId);
      const program = category?.programs.find(p => p.id === programId);
      this.targetProgramIsOnDemand = (program?.assignment_frequency === 'On Demand');

      this.targetProgramStatusForModules = program?.status || 'draft';

      try {
        const response = await this.$axios.get(`/orgadmin/trainings/organisations/${this.orgID}/all-modules`);
        if (response.data.success) {
          const rawModules = response.data.modules || [];

          this.assignableModules = rawModules.map(m => {
            const isDefault = m.is_default_video || m.IsVertexDefault || false;
            return {
              id: m.id || m.ID,
              training_video_id: m.legacy_video_id || m.LegacyVideoID,
              name: m.name || m.Name,
              type: (m.type || m.Type || '').toLowerCase(),
              scorm_version: m.scorm_version || m.ScormVersion,
              isDefaultVideo: isDefault,
              is_active: m.is_active !== undefined ? m.is_active : true,
              originalData: m
            };
          }).filter(m => m.is_active); // Only allow assigning ACTIVE modules!
        }
      } catch (error) {
        console.error("Failed to fetch assignable modules", error);
      }

      this.showAssignModuleModal = true;
    },

    async saveAssignedModules(selectedModules, autoDeploy) {
      try {
        const category = this.categories.find(c => c.id === this.targetCategoryIdForModules);
        if (!category) return;

        const program = category.programs.find(p => p.id === this.targetProgramIdForModules);
        if (!program) return;

        const existingIds = program.modules.map(m => m.id || m.ID);
        const newIds = selectedModules.map(m => m.id || m.ID);

        const allModuleIds = [...new Set([...existingIds, ...newIds])];

        // 1. Save modules to the Program
        const response = await this.$axios.post(`/orgadmin/trainings/programs/${program.id}/assign-modules`, {
          module_ids: allModuleIds
        });

        if (response.data.success) {
          program.modules = response.data.training_program.modules || [];
          this.showAssignModuleModal = false;

          if (autoDeploy) {
            let userIds = [];

            // If individual, we must fetch the currently enrolled users first
            if (program.assignment_type !== 'all') {
              const enrollRes = await this.$axios.get(`/orgadmin/trainings/organisations/${this.orgID}/programs/${program.id}/enrollments`);
              if (enrollRes.data.success && enrollRes.data.enrollments) {
                userIds = [...new Set(enrollRes.data.enrollments.map(e => e.user_id || e.UserID))].filter(id => this.activeUserIds.includes(id));
              }
            }

            // Trigger the sync endpoint (this handles the emails and shadow records we built earlier!)
            await this.$axios.post(`/orgadmin/trainings/organisations/${this.orgID}/programs/${program.id}/assign-to-users`, {
              user_ids: userIds,
              assignment_type: program.assignment_type || 'individual'
            });

            this.$toast.success("Trainings added and instantly deployed to enrolled users!");
          } else {
            this.$toast.success("Training assigned to program successfully.");
          }

          await this.fetchCategories();
        } else {
          this.$toast.error(response.data.message);
        }
      } catch (error) {
        this.$toast.error(error.response?.data?.message || "Failed to assign trainings.");
      }
    },

    assignProgram(programId) {
      let program = null;
      for (const category of this.categories) {
        program = category.programs.find(p => p.id === programId);
        if (program) break;
      }

      this.userAssignmentMode = 'program';
      this.targetProgramIdForUsers = programId;

      this.targetProgramIsAll = (program?.assignment_type === 'all' || (this.totalActiveUsers > 0 && program?.assigned_users_count >= this.totalActiveUsers));

      this.showAssignUserModal = true;
    },

    async saveUserAssignments(selectedUsers, programId, targetId, mode, isAll) {
      try {
        const userIds = selectedUsers.map(u => u.id || u.ID);

        if (mode === 'program') {

          const assignmentTypeString = isAll ? 'all' : 'individual';

          const response = await this.$axios.post(`/orgadmin/trainings/organisations/${this.orgID}/programs/${programId}/assign-to-users`, {
            user_ids: userIds,
            assignment_type: assignmentTypeString
          });

          if (response.data.success) {
            this.showAssignUserModal = false;

            for (const category of this.categories) {
              const program = category.programs.find(p => p.id === programId);
              if (program) {
                program.assigned_users_count = isAll ? 'All' : userIds.length;

                program.assignment_type = assignmentTypeString;
                break;
              }
            }

            this.$toast.success(response.data.message || 'Users assigned to program successfully!');
          } else {
            this.$toast.error(response.data.message);
          }

        } else if (mode === 'legacy_module') {
          // 🎬 SAVE LEGACY VERTEX VIDEO (Uses training_video_id)
          const response = await this.$axios.post(`/orgadmin/trainings/organisations/${this.orgID}/videos/${targetId}/reassign-to-users`, {
             user_ids: userIds
          });
          if (response.data.success) {
            this.showAssignUserModal = false;
            this.$toast.success(response.data.message || 'Legacy video deployed to selected users!');
          } else {
            this.$toast.error(response.data.message);
          }

        } else if (mode === 'custom_module') {
          const response = await this.$axios.post(`/orgadmin/trainings/organisations/${this.orgID}/training-modules/${targetId}/assign-adhoc`, {
             user_ids: userIds
          });
          if (response.data.success) {
            this.showAssignUserModal = false;
            this.$toast.success(response.data.message || 'Custom training deployed to selected users!');
          } else {
            this.$toast.error(response.data.message);
          }
        }
      } catch (error) {
        this.$toast.error(error.response?.data?.message || "Failed to assign users.");
      }
    },
    openNewCategoryModal() {
      this.isEditingCategory = false;
      this.selectedCategoryData = {};
      this.showCategoryModal = true;
    },
    openEditCategoryModal(category) {
      this.isEditingCategory = true;
      this.selectedCategoryData = { ...category };
      this.showCategoryModal = true;
    },
    deleteCategory(categoryId) {
      this.deletePayload = { id: categoryId, type: 'category', title: 'Delete Category', message: 'Are you sure you want to delete this Category and all its programs?', context: { categoryId } };
      this.showDeleteModal = true;
    },

    addProgram(categoryId) {
      this.activeCategoryId = categoryId;
      this.isEditingProgram = false;
      this.selectedProgramData = {};
      this.showProgramModal = true;
    },
    openEditProgramModal(program, categoryId) {
      this.activeCategoryId = categoryId;
      this.isEditingProgram = true;
      this.selectedProgramData = { ...program };
      this.showProgramModal = true;
    },
    async saveProgram(programData) {
      try {
        const payload = {
          title: programData.title,
          status: programData.status,
          assignment_frequency: programData.assignment_frequency,
          category_id: programData.category_id,
          assignment_type: 'all',
          enable_reminders: programData.enable_reminders !== false,
          is_mandatory: programData.is_mandatory !== false
        };

        if (this.isEditingProgram) {
          const response = await this.$axios.put(`/orgadmin/trainings/organisations/${this.orgID}/programs/${this.selectedProgramData.id}`, payload);

          if (response.data.success) {
            const category = this.categories.find(c => c.id === programData.category_id);
            if (category) {
              const index = category.programs.findIndex(p => p.id === this.selectedProgramData.id);
              if (index !== -1) {
                category.programs[index] = { ...category.programs[index], ...payload };
              }
            }
            this.$toast.success(response.data.message || 'Program updated successfully!');
          } else {
            this.$toast.error(response.data.message);
          }

        } else {
          const response = await this.$axios.post(`/orgadmin/trainings/organisations/${this.orgID}/programs`, payload);

          if (response.data.success) {
            const category = this.categories.find(c => c?.id === programData.category_id);
            if (category) {
              const newProg = response.data.training_program || {};
              category.programs.push({
                id: newProg.ID || newProg.id,
                title: newProg.Title || newProg.title || payload.title,
                status: newProg.Status || newProg.status || payload.status,
                assignment_frequency: newProg.AssignmentFrequency || newProg.assignment_frequency || payload.assignment_frequency,
                assignment_type: newProg.AssignmentType || newProg.assignment_type || payload.assignment_type,
                expanded: true,
                isDefault: false,
                modules: [],
                enable_reminders: newProg.EnableReminders !== undefined ? newProg.EnableReminders : payload.enable_reminders,
                is_mandatory: newProg.IsMandatory !== undefined ? newProg.IsMandatory : payload.is_mandatory,
              });
            }
            this.$toast.success(response.data.message || 'Program created successfully!');
          } else {
            this.$toast.error(response.data.message);
          }
        }

        this.showProgramModal = false;
      } catch (error) {
        this.$toast.error(error.response?.data?.message || "An error occurred saving the program.");
      }
    },
    deleteProgram(categoryId, programId) {
      this.deletePayload = { id: programId, type: 'program', title: 'Delete Program', message: 'Are you sure you want to delete this Program?', context: { categoryId, programId } };
      this.showDeleteModal = true;
    },
    removeModuleFromProgram(categoryId, programId, moduleId) {
      this.deletePayload = {
        id: moduleId,
        type: 'removeModule',
        title: 'Remove Training',
        message: 'Are you sure you want to remove this training from the program?',
        context: { categoryId, programId, moduleId },
        buttonText: 'Remove'
      };
      this.showDeleteModal = true;
    },

    openUploadModal() {
      if (this.isSavingModule) {
        this.showUploadModal = true;
        return;
      }

      this.isEditingModule = false;
      this.selectedModuleData = null;
      this.showUploadModal = true;
    },

    openEditLibraryModule(module) {
      this.isEditingModule = true;
      this.selectedModuleData = { ...module };
      this.showUploadModal = true;
    },

    async saveLibraryModule(moduleData) {
      try {
        this.isSavingModule = true;
        this.uploadProgress = 0;
        this.isProcessingUpload = false;

        let formData = new FormData();
        formData.append('type', moduleData.type);
        formData.append('name', moduleData.name);

        if (moduleData.type === 'scorm') {
          formData.append('scorm_version', moduleData.scorm_version);
        }
        if (moduleData.file) {
          formData.append('file', moduleData.file);
        }
        if (moduleData.thumbnail) {
          formData.append('thumbnail', moduleData.thumbnail);
        }

        const isEdit = this.isEditingModule;
        const moduleId = this.selectedModuleData ? this.selectedModuleData.id : null;

        // Give them a gentle toast so they know they aren't trapped
        this.$toast.info(`Upload started. You can close the modal and continue working.`, { duration: 5000 });

        // Axios Configuration for large files & live progress
        const axiosConfig = {
          headers: { 'Content-Type': 'multipart/form-data' },
          timeout: 0,
          onUploadProgress: (progressEvent) => {
            const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
            this.uploadProgress = percentCompleted;

            if (percentCompleted >= 100) {
              this.isProcessingUpload = true;
            }
          }
        };

        let response;
        if (isEdit) {
          response = await this.$axios.put(`/orgadmin/trainings/organisations/${this.orgID}/training-modules/${moduleId}`, formData, axiosConfig);
        } else {
          response = await this.$axios.post(`/orgadmin/trainings/organisations/${this.orgID}/training-modules`, formData, axiosConfig);
        }

        if (response.data.success) {
          this.$toast.success(response.data.message || `"${moduleData.name}" saved successfully!`);
          this.showUploadModal = false;
          await this.fetchModules();
          if (isEdit) await this.fetchCategories();
        } else {
          this.$toast.error(response.data.message);
        }

      } catch (error) {
        this.$toast.error(error.response?.data?.message || "An error occurred while uploading.");
      } finally {
        this.isSavingModule = false;
        this.uploadProgress = 0;
        this.isProcessingUpload = false;
      }
    },

    async performBackgroundUpload(formData, isEdit, moduleId, moduleName) {
      try {
        // Set timeout: 0 so Axios doesn't kill the request for massive files!
        const axiosConfig = {
          headers: { 'Content-Type': 'multipart/form-data' },
          timeout: 0
        };

        if (isEdit) {
          const response = await this.$axios.put(`/orgadmin/trainings/organisations/${this.orgID}/training-modules/${moduleId}`, formData, axiosConfig);

          if (response.data.success) {
            this.$toast.success(response.data.message || `"${moduleName}" updated successfully!`);
            await this.fetchModules();
            await this.fetchCategories();
          } else {
            this.$toast.error(`Failed to update "${moduleName}": ` + response.data.message);
          }

        } else {
          const response = await this.$axios.post(`/orgadmin/trainings/organisations/${this.orgID}/training-modules`, formData, axiosConfig);

          if (response.data.success) {
            this.$toast.success(response.data.message || `"${moduleName}" uploaded successfully!`);
            await this.fetchModules();
          } else {
            this.$toast.error(`Failed to upload "${moduleName}": ` + response.data.message);
          }
        }

      } catch (error) {
        this.$toast.error(error.response?.data?.message || `An error occurred while uploading "${moduleName}".`);
      }
    },

    deleteLibraryModule(moduleId) {
      this.deletePayload = { id: moduleId, type: 'libraryModule', title: 'Delete Training', message: 'Are you sure you want to completely delete this module from the library?', context: { moduleId } };
      this.showDeleteModal = true;
    },
    handleDeleteConfirm(event) {
      if (!event.delete) return;
      const { type, context } = this.deletePayload;

      if (type === 'category') {
        this.$axios.delete(`/orgadmin/trainings/organisations/${this.orgID}/categories/${context.categoryId}`)
          .then(response => {
            if (response.data.success) {
              this.categories = this.categories.filter(c => c.id !== context.categoryId);
              this.showDeleteModal = false;
              this.$toast.success(response.data.message);
            } else {
              this.$toast.error(response.data.message);
            }
          })
          .catch(error => {
            this.$toast.error(error.response?.data?.message || "Failed to delete category.");
          });
      }

      else if (type === 'program') {
        this.$axios.delete(`/orgadmin/trainings/programs/${context.programId}`)
          .then(response => {
            if (response.data.success) {
              const category = this.categories.find(c => c.id === context.categoryId);
              if (category) {
                category.programs = category.programs.filter(p => p.id !== context.programId);
              }
              this.showDeleteModal = false;
              this.$toast.success(response.data.message || 'Program successfully deleted!');
            } else {
              this.$toast.error(response.data.message);
            }
          })
          .catch(error => {
            this.$toast.error(error.response?.data?.message || "Failed to delete program.");
            this.showDeleteModal = false;
          });
      }

      else if (type === 'removeModule') {
        this.$axios.delete(`/orgadmin/trainings/programs/${context.programId}/modules/${context.moduleId}`)
          .then(response => {
            if (response.data.success) {
              const category = this.categories.find(c => c.id === context.categoryId);
              const program = category?.programs.find(p => p.id === context.programId);

              if (program) {
                program.modules = program.modules.filter(m => m.id !== context.moduleId);
              }
              this.showDeleteModal = false;
              this.$toast.success(response.data.message || 'Module successfully unlinked!');
            } else {
              this.$toast.error(response.data.message);
            }
          })
          .catch(error => {
            this.$toast.error(error.response?.data?.message || "Failed to unlink module.");
            this.showDeleteModal = false;
          });
        }
      else if (type === 'libraryModule') {
        this.deletingModuleId = context.moduleId;

        this.$axios.delete(`/orgadmin/trainings/training-modules/${context.moduleId}`)
          .then(response => {
            if (response.data.success) {
              this.libraryModules = this.libraryModules.filter(m => m.id !== context.moduleId);

              this.categories.forEach(cat => {
                cat.programs.forEach(prog => {
                  prog.modules = prog.modules.filter(m => m.id !== context.moduleId);
                });
              });

              this.showDeleteModal = false;
              this.$toast.success(response.data.message || 'Module successfully deleted!');
            } else {
              this.$toast.error(response.data.message);
            }
          })
          .catch(error => {
            this.$toast.error(error.response?.data?.message || "Failed to delete training.");
            this.showDeleteModal = false;
          })
          .finally(() => {
            this.deletingModuleId = null;
          });
      }

     this.showDeleteModal = false;
    },
    onDragStart(index) {
      this.draggedItemIndex = index;
    },

    async onDrop(categoryId, program, dropIndex) {
      // Security Check: Don't allow drops on Default Vertex Programs
      if (program.isDefault) return;

      if (this.draggedItemIndex === null || this.draggedItemIndex === dropIndex) return;

      // 1. Move the item in the local Vue array
      const draggedItem = program.modules.splice(this.draggedItemIndex, 1)[0];
      program.modules.splice(dropIndex, 0, draggedItem);
      this.draggedItemIndex = null;

      // 2. Extract the newly ordered array of IDs
      const newOrderedIds = program.modules.map(m => m.id || m.ID);

      // 3. Save the new sequence silently in the background
      try {
        const response = await this.$axios.post(`/orgadmin/trainings/programs/${program.id}/assign-modules`, {
          module_ids: newOrderedIds
        });

        if (response.data.success) {
          this.$toast.success("Training sequence updated.");
        } else {
          this.$toast.error("Failed to save new sequence.");
        }
      } catch (error) {
        this.$toast.error(error.response?.data?.message || "Failed to save new sequence.");
      }
    }
  },

  computed: {
    organisation(){
      return this.$store.state.auth.isSuperAdmin ? this.$store.state.user.organisation.name : this.$store.state.user.organisation.organisation;
    },
    isBambooEnabled() {
      if (this.$store.state.auth.isSuperAdmin || this.$helper.isVertexAnalyst() )
        return this.$store.state.user.organisation.bamboo_hr_api_key != "" ? true : false
      else return this.$store.state.user.isBambooEnabled
    },
    currentProgramModuleIds() {
      if (!this.targetCategoryIdForModules || !this.targetProgramIdForModules) return [];
      const category = this.categories.find(c => c.id === this.targetCategoryIdForModules);
      if (!category) return [];
      const program = category.programs.find(p => p.id === this.targetProgramIdForModules);
      if (!program) return [];
      return program.modules.map(m => m.id);
    },

    filteredCategories() {
      if (!this.search || this.search.trim() === '') {
        return this.categories;
      }

      const query = this.search.toLowerCase();

      // Deep clone and filter the tree
      return this.categories.map(category => {
        // 1. Check if the Category itself matches
        const isCategoryMatch = category.name.toLowerCase().includes(query);

        // 2. Map and filter the Programs
        const matchedPrograms = category.programs.map(program => {
          // Check if the Program title matches
          const isProgramMatch = program.title.toLowerCase().includes(query);

          // 3. Filter the Modules
          // If the Category OR Program matched, we show ALL modules.
          // Otherwise, we ONLY show the modules that match the search term.
          const matchedModules = (isCategoryMatch || isProgramMatch)
            ? program.modules
            : program.modules.filter(m => m.name.toLowerCase().includes(query));

          return {
            ...program,
            expanded: matchedModules.length > 0 || isProgramMatch, // Auto-expand if it has matches
            modules: matchedModules
          };
        }).filter(program => isCategoryMatch || program.title.toLowerCase().includes(query) || program.modules.length > 0);

        return {
          ...category,
          expanded: matchedPrograms.length > 0 || isCategoryMatch, // Auto-expand if it has matches
          programs: matchedPrograms
        };
      }).filter(category => category.name.toLowerCase().includes(query) || category.programs.length > 0);
    },

    filteredLibraryModules() {
    //   if (!this.search || this.search.trim() === '') {
    //     return this.libraryModules;
    //   }
    //   const query = this.search.toLowerCase();
    //   return this.libraryModules.filter(mod => mod.name.toLowerCase().includes(query));
      return this.libraryModules;
    }
  },

  watch: {
    organisation(){
      if (this.$store.state.auth.accessToken == null) return
      this.orgID = this.$store.state.user.organisation.id
      this.libraryPagination.page = 1;
      this.init();
    },

    search: debounce(function() {
      if (this.activeTab === 'catalog') {
        return;
      }

      this.libraryPagination.page = 1;
      this.fetchModules();
    }, 600),

    'libraryPagination.pageSize'() {
      this.libraryPagination.page = 1;
      this.fetchModules();
    },

    activeTab(newTab) {
      if (newTab === 'modules') {
        this.libraryPagination.page = 1;
        this.fetchModules();
      }
    }
  }
}
</script>

<style scoped>

/* Settings Overrides */
.form-control { border-radius: 10px; }
.btn-create { border-radius: 20px; font-size:13px; font-weight: 900; padding: 0 15px; }
.text-default{ color: #435666; }
.form-check-input:checked { background-color: #00A0C1; border-color: #00A0C1; }
.default { border-color: #00A0C1; color: #00A0C1; margin:3px; }
.default:hover { background: #00A0C1; color:white; }
.btn:focus { outline: none; box-shadow: none; }

/* Custom Sliders and Icons */
.custom-icon-btn { display: flex; align-items: center; justify-content: center; padding: 0; border-radius: 50%; }
.custom-slider { position: relative; width: 42px; height: 22px; margin-right: 5px; }
.custom-slider .slider { position: absolute; top: 1px; left: 1px; width: 40px; height: 20px; background-color: #B5DAC6; border-radius: 11px; cursor: pointer; transition: 0.4s; }
.custom-slider .slider-button { position: absolute; top: 0px; left: 1px; width: 20px; height: 20px; background-color: #00B972; border-radius: 50%; transition: 0.4s; }
.form-check-input:checked + .slider .slider-button { transform: translateX(20px); background-color: #00B972; }
.form-check-input:not(:checked) + .slider .slider-button { background-color: grey; transform: translateX(0); }
.form-check-input:not(:checked) + .slider { background-color: #bebebe; }
.form-check-input { opacity: 0; width: 0; height: 0; }
.custom-disabled-btn:disabled { background-color: #435666; border-color: #435666; }

/* Scoped Typography & Layout (From SCORM) */
.bg-light-surface { background-color: #f8fafc; }
.main-app-card { overflow: hidden; }

/* Custom Tabs mimicking the image */
.custom-tabs-header { display: flex; background: white; border-bottom: 1px solid #e2e8f0; padding: 0 1.5rem; }
.custom-tab { background: transparent; border: none; padding: 1rem 1.5rem; font-weight: 600; font-size: 0.95rem; color: #64748b; cursor: pointer; border-bottom: 3px solid transparent; transition: all 0.2s; }
.custom-tab:hover { color: #00a0c1; }
.custom-tab.active { color: #0f172a; border-bottom-color: #00a0c1; }
.section-title { font-weight: 700; color: #1e293b; font-size: 1.2rem; }

/* Accordion Styles */
.accordion-category { margin-bottom: 0.75rem; border: 1px solid #cbd5e1; border-radius: 10px; background-color: white; overflow: hidden; box-shadow: 0 1px 2px rgba(0,0,0,0.02); }
.category-header { padding: 0.85rem 1.25rem; background-color: #f1f5f9; cursor: pointer; transition: background-color 0.2s; }
.category-header:hover { background-color: #e2e8f0; }
.category-header.is-expanded { border-bottom: 1px solid #cbd5e1; background-color: #e0e7ff; }

.accordion-program { border: 1px solid #cbd5e1; border-radius: 8px; overflow: hidden; background-color: white; }
.program-header { padding: 0.75rem 1.25rem; background-color: #f8fafc; cursor: pointer; border-bottom: 1px solid transparent; }
.program-header:hover { background-color: #f1f5f9; }
.program-header.is-expanded { border-bottom: 1px solid #cbd5e1; background-color: #f0f9ff; }

.program-body { border-top: 1px solid #e2e8f0; }
.module-item { display: flex; justify-content: space-between; align-items: center; padding: 0.75rem 1rem; margin: 0.4rem 1rem; border: 1px solid #e2e8f0; border-radius: 6px; background-color: white; transition: box-shadow 0.2s; }
.module-item:hover { box-shadow: 0 2px 4px rgba(0,0,0,0.04); border-color: #cbd5e1; }
.module-icon { font-size: 1.1rem; }

/* Tiny Admin Buttons within Accordions */
.btn-xs { padding: 0.2rem 0.6rem; font-size: 0.75rem; font-weight: 600; }
.header-icon-btn { background: transparent; border: none; color: #94a3b8; width: 28px; height: 28px; border-radius: 50%; display: inline-flex; align-items: center; justify-content: center; transition: all 0.2s; }
.header-icon-btn:hover { background-color: #cbd5e1; color: #00a0c1; }
.header-icon-btn.delete-btn:hover { background-color: #fee2e2; color: #dc3545; }

/* Utility / Circle Buttons */
.btn-circle { width: 32px; height: 32px; padding: 0; border-radius: 50%; display: inline-flex; align-items: center; justify-content: center; border: 1px solid #e2e8f0; }
.btn-circle:hover { background-color: #e2e8f0; }

/* --- Hierarchy Icon Colors --- */
.icon-category { color: #00a0c1; /* Brand Teal */ }
.icon-program { color: #f59e0b; /* Golden Orange */ }
.icon-module { color: #94a3b8; /* Soft Purple */ }

/* --- Brand Color Overrides --- */
.text-theme { color: #00a0c1 !important; }
.bg-theme { background-color: #00a0c1 !important; }
.btn-theme { background-color: #00a0c1 !important; border-color: #00a0c1 !important; }
.btn-theme:hover { background-color: #008da8 !important; border-color: #008da8 !important; }
.btn-outline-theme { border-color: #00a0c1; color: #00a0c1; }
.btn-outline-theme:hover { background-color: #00a0c1; color: white; }

@media screen and (max-width: 768px) {
  .custom-slider .slider-button { width: 18px; height: 18px; }
  .custom-icon-btn svg { width: 14px; height: 14px; }
}

/* Custom Pure CSS Toggle Switch (Bulletproof) */
.pure-toggle { position: relative; display: inline-block; width: 44px; height: 24px; }
.pure-toggle input { opacity: 0; width: 0; height: 0; }
.pure-slider { position: absolute; cursor: pointer; top: 0; left: 0; right: 0; bottom: 0; background-color: #cbd5e1; transition: .3s; border-radius: 24px; }

/* 🚨 FIX: Default state is now a greyish slate dot */
.pure-slider:before { position: absolute; content: ""; height: 18px; width: 18px; left: 3px; bottom: 3px; background-color: #94a3b8; transition: .3s; border-radius: 50%; box-shadow: 0 2px 4px rgba(0,0,0,0.2); }

.pure-toggle input:checked + .pure-slider { background-color: #B5DAC6; }

/* 🚨 FIX: Turn the dot green only when checked */
.pure-toggle input:checked + .pure-slider:before { transform: translateX(20px); background-color: #00B972; }

/* -----------------------------------------
   Sleek & Symmetrical Search Bar
----------------------------------------- */
.sleek-search-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}

.sleek-search-wrapper .search-icon {
  position: absolute;
  left: 14px;
  color: #94a3b8; /* Soft slate color */
  font-size: 0.85rem;
  pointer-events: none; /* Ensures clicking the icon still focuses the input! */
}

.sleek-search-input {
  width: 240px; /* Slightly wider for a modern feel */
  padding: 0.45rem 1rem 0.45rem 2.2rem; /* Extra left padding makes room for the icon */
  border: 1px solid #e2e8f0;
  border-radius: 50px; /* Perfect pill shape */
  background-color: #f8fafc; /* Very light slate background */
  font-size: 0.85rem;
  color: #334155;
  transition: all 0.25s ease;
  outline: none;
}

.sleek-search-input::placeholder {
  color: #94a3b8;
  font-weight: 500;
}

/* The "Glow" effect when clicked */
.sleek-search-input:focus {
  background-color: #ffffff;
  border-color: #00a0c1; /* Your brand teal */
  box-shadow: 0 0 0 3px rgba(0, 160, 193, 0.15); /* Soft, symmetrical outer glow */
}

.pagination-arrow {
  margin: 0 8px;
  color: #00a0c1;
  cursor: pointer;
}
.pagination-arrow.disabled {
  color: #ccc;
  cursor: not-allowed;
}
.pagination-label {
  display: inline-block;
  min-width: 120px;
}

</style>